<template>
    <div class="appbox bg-color-primary">
        <div class="appbox-image">
            <ImageLazy 
                image-url="/uploads/images/app/bg-1.jpg"
                :height="425"
                :is-background="true"
            />
        </div>
        <div class="grid grid-11-14 grid-spaceless">
            <div class="appbox-body flex flex-column flex-content-center flex-baseline">
                <header>
                    <img 
                        src="/uploads/images/app/pobierz.png" 
                        alt="pobierz"
                    >
                </header>
                <p 
                    v-bastards
                    class="fs-24 fs-lh-30 text-color-contrast"
                >
                    darmową aplikację MAKRO<br>i rozpocznij korzystanie już dziś!
                </p>
                <p>
                    <a
                        href="https://play.google.com/store/apps/details?id=pl.itcraft.makroapp"
                        target="_blank"
                        rel="noreferrer"
                        title="Pobierz aplikację MAKRO w Google Play"
                    >
                        <img 
                            src="/uploads/images/app/google.png" 
                            alt="Google Play"
                        >
                    </a> 
                    <a
                        href="https://itunes.apple.com/us/app/makro/id1146761397?ls=1&mt=8"
                        target="_blank"
                        rel="noreferrer"
                        title="Pobierz aplikację MAKRO w App Store"
                    >
                        <img 
                            src="/uploads/images/app/apple-store.png" 
                            alt="Apple Store"
                        >
                    </a>
                </p>
            </div> 
            <div class="appbox-video flex flex-column flex-content-center">
                <iframe
                    :src="youtubeEmbedUrl" 
                    width="599" 
                    height="337" 
                    frameborder="0" 
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                    allowfullscreen 
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            youtubeVideo: {
                id: 'BiVtrAdZrGQ',
                autoplay: 1,
                controls: 1,
                loop: 1,
                mute: 1,
                color: `white`
            }
        }
    },

    computed: {
        youtubeEmbedUrl() {
            const query = [
                `autoplay=${this.youtubeVideo.autoplay || 0}`,
                `controls=${this.youtubeVideo.controls || 0}`,
                `loop=${this.youtubeVideo.loop || 0}`,
                `playlist=${this.youtubeVideo.id || null}`,
                `mute=${this.youtubeVideo.mute || 0}`,
                `color=${this.youtubeVideo.color || 'red'}`
            ]

            return `https://www.youtube.com/embed/${this.youtubeVideo.id}?${query.join('&')}`
        }
    }
}
</script>

<style lang="scss">
.appbox {
    color: $color-default-contrast;
    position: relative;
    min-height: 425px;
    margin: 22px 0 32px;

    > .grid {
        @include position-cover();
    }

    &-body {
        padding-left: 115px;

        > header {
            padding-bottom: 22px;
        }

        p {
            & + p {
                padding-top: 37px;
            }

            a {
                & + a {
                    margin-left: 16px;
                }
            }
        }
    }

    &-video {
        text-align: right;
        padding-right: 100px;

        .is-ie & {
            padding-top: 44px;
        }
    }

    @media (max-width: $screen-page) {
        &-body {
            padding-left: 45px;
        }

        &-video {
            float: right;
            padding-right: 45px;
        }
    }

    @media (max-width: $screen-laptop) {
        min-height: 670px;

        > .grid {
            display: block;
        }

        &-image {
            .image-lazy {
                > * {
                    height: 670px !important;
                }
            }
        }

        &-body {
            text-align: center;
            display: block;
            padding: 40px 5px 20px;
        }

        &-video {
            float: none;
            display: block;
            text-align: center;
            padding: 0 5px 0;

            > iframe {
                max-width: calc(100% - 30px);
            }
        }
    }

    @media (max-width: $screen-mobile-large) {
        min-height: 625px;

        &-image {
            .image-lazy {
                > * {
                    height: 625px !important;
                }
            }
        }

        &-video {
            > iframe {
                max-height: 300px;
            }
        }
    }
}
</style>
